import { GET_E_MAGAZINE, SET_LOADING_E_MAGAZINE, SET_PAGINATION_E_MAGAZINE } from '../constant';

const initialState = {
  eMagazine: [],
  eMagazinePagination: 0,
  loadingEMagazine: false,
  totalEMagazine: 0,
};

const eMagazineReducer = function (state = initialState, action) {
  switch (action.type) {
    case SET_LOADING_E_MAGAZINE: {
      return {
        ...state,
        loadingEMagazine: action?.payload,
      };
    }
    case SET_PAGINATION_E_MAGAZINE: {
      return {
        ...state,
        eMagazinePagination: action?.payload,
      };
    }
    case GET_E_MAGAZINE: {
      return {
        ...state,
        eMagazine: action?.payload?.data || [],
        totalEMagazine: action?.payload?.total,
        loadingEMagazine: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default eMagazineReducer;
